import { SIMILAR_HOMES_API_ERROR,
         SIMILAR_HOMES_DATA_NOT_AVAILABLE,
         SIMILAR_HOMES_SAVE_BILLING_CYCLE_PERIOD,
         SIMILAR_HOMES_SET_HIGHCHARTS_DATA,
         SIMILAR_HOMES_SET_ARROW_DISABLED,
         SIMILAR_HOMES_UPDATE_HIGHCHARTS_OBJECT,
         SIMILAR_HOMES_SAVE_BC_DATA,
         SIMILAR_HOMES_CHANGE_YEAR_OFFSET,
         SIMILAR_HOMES_COMPARISON_DATA,
         SIMILAR_HOMES_CHANGE_APPLIANCE,
         SIMILAR_HOMES_SAVE_APPLIANCE_NAVBAR_LIST,
         SIMILAR_HOMES_SAVE_CHART_API_PAYLOAD } from "../../actions/insightsSimilarHomesActions";

const insightsSimilarHomesReducer = (state = {
    options: {},
    mode: 'SHC_BC',
    usageGraphStyle: 'Line',
    switchGasElectric: 'electric',
    dataXAxis: [],
    bcTimeStampsData: [],
    insightsSHChartsData: [],
    bcIndexOffset: 0,
    youSeriesData: [],
    averageSeriesData: [],
    efficientSeriesData: [],
    insightsDataLeftArrowDisabled: false,
    insightsDataRightArrowDisabled: true,
    currentBillingCycleInfo: '',
    isSHChartLoading: true,
    apiErrorMessage: '',
    dataNotAvailableText: '',
    bcDurations: [],
    dataEmptyText: '',
    showDisclaimerMissingInterval: false,
    showDisclaimerApplianceMissing: false,
    selectedAppliance: null,
    shcData: [],
    appliancesSHCList: null,
    shcChartsPayload: null
}, action) => {
  switch (action.type) {
        case SIMILAR_HOMES_API_ERROR:
            state = {
                ...state,
                apiErrorMessage: action.payload.dataNotAvailableText,
                isSHChartLoading: false
            }
            break;
        case SIMILAR_HOMES_DATA_NOT_AVAILABLE:
        case SIMILAR_HOMES_SAVE_BILLING_CYCLE_PERIOD:
        case SIMILAR_HOMES_SET_HIGHCHARTS_DATA:
        case SIMILAR_HOMES_SET_ARROW_DISABLED:
        case SIMILAR_HOMES_SAVE_BC_DATA:
        case SIMILAR_HOMES_CHANGE_YEAR_OFFSET:
        case SIMILAR_HOMES_COMPARISON_DATA:
        case SIMILAR_HOMES_UPDATE_HIGHCHARTS_OBJECT:
        case SIMILAR_HOMES_CHANGE_APPLIANCE:
        case SIMILAR_HOMES_SAVE_APPLIANCE_NAVBAR_LIST:
        case SIMILAR_HOMES_SAVE_CHART_API_PAYLOAD:
            state = {
                ...state,
                ...action.payload
            };
            break;
        default:
            break;
  }
  return state;
};

export default insightsSimilarHomesReducer;
